import { localize } from "utils/localizer";

const i18n = {
    address: {
        en: "Address",
        de: "Anschrift",
    },
    addresseeName: {
        en: "Addressee name",
        de: "Ansprechpartner",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    autoAcceptMembershipRequests: {
        en: "Automatically accept membership requests",
        de: "Mitgliedschaftsanfragen automatisch annehmen",
    },
    autoInviteMembersToEvents: {
        en: "Automatically invite new members to upcoming events",
        de: "Neue Mitglieder automatisch zu kommenden Events einladen",
    },
    areYouSure: {
        en: "Are you sure?",
        de: "Bist du sicher?",
    },
    balance: {
        en: "Balance",
        de: "Saldo",
    },
    bookings: {
        en: "Bookings",
        de: "Buchungen",
    },
    bookingAtom: {
        en: "Start of booking possible every",
        de: "Buchungsbeginn möglich alle",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    changeClubVisibility: {
        en: "Change Location Visibility",
        de: "Sichtbarkeit Sportstätte ändern",
    },
    checkInRequired: {
        en: "Check-in required",
        de: "Check-in benötigt",
    },
    city: {
        en: "City",
        de: "Stadt",
    },
    clubDescription: {
        en: "Description",
        de: "Beschreibung",
    },
    clubEmail: {
        en: "E-Mail Address",
        de: "E-Mail Adresse",
    },
    clubKey: {
        en: "Location key",
        de: "Sportstätten-Schlüssel",
    },
    organisationKey: {
        en: "Organization key",
        de: "Organisations-Schlüssel",
    },
    clubPhone: {
        en: "Phone",
        de: "Telefon",
    },
    clubWebsite: {
        en: "Website",
        de: "Webseite",
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    comingUpBookingMinsDesc: {
        en: "Sets a user's maximum number of booking minutes in the future, that is, if a user has an upcoming booking of 60 minutes, he/she can only create a new booking after this booking has passed.",
        de: "Beschreibt, wie viel gebuchte Minuten ein User in der Zukunft haben kann. Hätte ein User z.B. für morgen eine Stunde gebucht - sprich 60 anstehende Buchungsminuten - dann kann er/sie erst nach Ablauf dieser Stunde wieder eine Buchung vornehmen.",
    },
    connectWithStripe: {
        en: "Connect with Stripe",
        de: "Mit Stripe verbinden",
    },
    connectWithStripeSuccess: {
        en: "Successfully connected with Stripe",
        de: "Erfolgreich mit Stripe verbunden",
    },
    connectingWithStripe: {
        en: "Connecting with Stripe ...",
        de: "Verbinde mit Stripe ...",
    },
    contact: {
        en: "Contact",
        de: "Kontakt",
    },
    contactPersons: {
        en: "Contact persons",
        de: "Kontaktpersonen",
    },
    coronaReady: {
        en: "Enable COVID-19 contact tracing for this location",
        de: "COVID-19 Kontakterfassung für diese Sportstätte aktivieren",
    },
    covid19: {
        en: "COVID-19",
        de: "COVID-19",
    },
    country: {
        en: "Country",
        de: "Land",
    },
    createQrCode: {
        en: "Create QR Code",
        de: "QR-Code erstellen",
    },
    dangerZone: {
        en: "Danger zone",
        de: "Gefahrenzone",
    },
    dark: {
        en: "Dark",
        de: "Dunkel",
    },
    deactivate: {
        en: "Deactivate",
        de: "Deaktivieren",
    },
    deactivateStripe: {
        en: "Deactivate Stripe",
        de: "Stripe deaktivieren",
    },
    deactivateStripeDesc: {
        en: "Deactivating Stripe is only possible if your current payout balance is 0,00 €. Note that this will also set your location visibility to private.",
        de: "Stripe zu deaktivieren ist nur möglich, wenn dein Saldo 0,00 € beträgt. Beachte, dass die Sichtbarkeit der Sportstätte dabei auf privat gestellt wird.",
    },
    deactivateStripeSuccess: {
        en: "Stripe deactivated successfully",
        de: "Stripe erfolgreich deaktiviert",
    },
    deleteClub: {
        en: "Delete Location",
        de: "Sportstätte löschen",
    },
    deleteClubDesc: {
        en: "This deletes your location irrevocably including all associated data. All members will be removed from the location and future bookings on courts of this location will be cancelled.",
        de: "Deine Sportstätte wird inklusive aller dazugehörigen Daten unwiderruflich gelöscht. Alle Mitglieder werden aus der Sportstätte entfernt und zukünftige Buchungen auf Plätzen der Sportstätte storniert.",
    },
    deleteClubSuccess: {
        en: "Location deleted successfully",
        de: "Sportstätte erfolgreich gelöscht",
    },
    deleteIrrevocably: {
        en: "Delete irrevocably",
        de: "Unwiderruflich löschen",
    },
    edit: {
        en: "Edit",
        de: "Bearbeiten",
    },
    editClub: {
        en: "Edit Location",
        de: "Sportstätte bearbeiten",
    },
    embedDashboard: {
        en: "Embed Dashboard",
        de: "Dashboard einbetten",
    },
    embedLink: {
        en: "Embed Link",
        de: "Einbettungs-Link",
    },
    enterName: {
        en: "Enter name",
        de: "Name eingeben",
    },
    export: {
        en: "Export",
        de: "Exportieren",
    },
    fromAddress: {
        en: "From Address",
        de: "Von Adresse",
    },
    geofence: {
        en: "Geofence",
        de: "Geofence",
    },
    geofenceRadius: {
        en: "Radius around location coordinates",
        de: "Radius um Koordinaten Sportstätte",
    },
    general: {
        en: "General",
        de: "Allgemeines",
    },
    hadCloseContact: {
        en: "Close contact",
        de: "Enger Kontakt",
    },
    identifyContacts: {
        en: "Trace Contacts",
        de: "Kontakte ermitteln",
    },
    latitude: {
        en: "Latitude",
        de: "Breitengrad",
    },
    light: {
        en: "Light",
        de: "Hell",
    },
    limitBookingsToOneHour: {
        en: "Limit bookings to 60 minutes",
        de: "Buchungen auf 60 Minuten begrenzen",
    },
    locationRestriction: {
        en: "Location restriction",
        de: "Ortsbeschränkung",
    },
    locationRestrictionDesc: {
        en: {
            none: "Bookings are possible from everywhere.",
            "check-in": "Player needs to check-in at the court when the booking starts.",
            "geo-fence": "Bookings are only possible within the geofence radius of the location.",
        },
        de: {
            none: "Buchungen sind von überall möglich.",
            "check-in": "Spieler muss zu Buchungsbeginn vor Ort einchecken.",
            "geo-fence": "Buchungen sind nur innerhalb des Geofence-Radius vor Ort möglich.",
        },
    },
    longitude: {
        en: "Longitude",
        de: "Längengrad",
    },
    mainSportForm: {
        en: "Main sport form",
        de: "Hauptsportart",
    },
    makePrivate: {
        en: "Make private",
        de: "Privat schalten",
    },
    makePublic: {
        en: "Make public",
        de: "Öffentlich schalten",
    },
    maxComingUp: {
        en: "Maximum upcoming booking duration",
        de: "Maximale anstehende Buchungsdauer",
    },
    members: {
        en: "Members",
        de: "Mitglieder",
    },
    memberTaxRate: {
        en: "Tax rate for member payments",
        de: "Steuersatz für Mitgliederzahlungen",
    },
    minDuration: {
        en: "Minimum booking duration",
        de: "Minimale Buchungsdauer",
    },
    minutes: {
        en: "minutes",
        de: "Minuten",
    },
    moreInformation: {
        en: "More Information",
        de: "Weitere Informationen",
    },
    name: {
        en: "Name",
        de: "Name",
    },
    newOwner: {
        en: "New owner",
        de: "Neuer Eigentümer",
    },
    no: {
        en: "No",
        de: "Nein",
    },
    none: {
        en: "None",
        de: "Keine",
    },
    notify: {
        en: "Notify",
        de: "Benachrichtigen",
    },
    notifyCovidConfirm: {
        en: "By clicking \"Notify\", we will inform all listed contact persons via mail.",
        de: "Mit einem Klick auf \"Benachrichtigen\" informieren wir alle gelisteten Kontaktpersonen per Mail.",
    },
    notifyCovidDesc: {
        en: "This notifies all possible contacts of a COVID-19 infected person.",
        de: "Hiermit werden alle potentiellen Kontakte der mit COVID-19 infizierten Person benachrichtigt.",
    },
    notifySuccess: {
        en: "Notifications sent successfully",
        de: "Benachrichtigungen erfolgreich versendet",
    },
    ok: {
        en: "Ok",
        de: "Ok",
    },
    ownership: {
        en: "Ownership",
        de: "Eigentümerschaft",
    },
    payoutsArePaidMonthly: {
        en: "Payouts are paid monthly",
        de: "Auszahlungen erfolgen monatlich",
    },
    person: {
        en: "Person",
        de: "Person",
    },
    personQuery: {
        en: "Enter name, address or phone number",
        de: "Name, Adresse oder Telefonnummer eingeben",
    },
    postalCode: {
        en: "Postal code",
        de: "Postleitzahl",
    },
    preview: {
        en: "Preview",
        de: "Vorschau",
    },
    privateClubDesc: {
        en: (lastChange: string) => ` Changing the visibility has a big impact on all location members and therefore can only be done once every 24 hours. Since ${lastChange}, the club is listed as private, that is, only members can create bookings.`,
        de: (lastChange: string) => `Die Änderung der Sichtbarkeit hat einen großen Einfluss auf alle Mitglieder der Sportstätte und kann daher nur einmal alle 24 Stunden vollzogen werden. Seit ${lastChange} ist die Sportstätte als privat gelistet, d.h. Buchungen können nur durch Mitglieder erfolgen.`,
    },
    prohibitStandardBookings: {
        en: "Prohibit bookings by members or public users",
        de: "Buchungen durch Mitglieder und Externe verbieten",
    },
    publicClubDesc: {
        en: (lastChange: string) => `Changing the visibility has a big impact on all location members and therefore can only be done once every 24 hours. Since ${lastChange}, the club is listed as public, that is, every PLAYSPORTS user can create bookings.`,
        de: (lastChange: string) => `Die Änderung der Sichtbarkeit hat einen großen Einfluss auf alle Mitglieder der Sportstätte und kann daher nur einmal alle 24 Stunden vollzogen werden. Seit ${lastChange} ist die Sportstätte als öffentlich gelistet, d.h. Buchungen können durch jeden PLAYSPORTS Nutzer erfolgen.`,
    },
    save: {
        en: "Save",
        de: "Speichern",
    },
    savedSuccessfully: {
        en: "Saved successfully",
        de: "Erfolgreich gespeichert",
    },
    deletedSuccessfully: {
        en: "Successfully deleted",
        de: "Erfolgreich gelöscht",
    },
    shortName: {
        en: "Short / Display name",
        de: "Kurz-/Anzeigename",
    },
    showPayouts: {
        en: "Show payouts",
        de: "Auszahlungen anzeigen",
    },
    sinceDate: {
        en: "Since date",
        de: "Seit Datum",
    },
    stateOrProvince: {
        en: "State",
        de: "Bundesland",
    },
    street: {
        en: "Street",
        de: "Straße",
    },
    stripe: {
        en: "Stripe",
        de: "Stripe",
    },
    stripePrereq: {
        en: "Tax number and tax rate are required to use Stripe.",
        de: "Steuernummer und Steuersatz sind notwendig um Stripe zu benutzen.",
    },
    stripeRequired: {
        en: "To make your location public, a Stripe account is required.",
        de: "Um die Sportstätte öffentlich zu schalten, ist eine Anbindung an Stripe notwendig.",
    },
    taxes: {
        en: "Taxes",
        de: "Steuern",
    },
    taxNumber: {
        en: "Tax number",
        de: "Steuernummer",
    },
    taxRate: {
        en: "Tax rate",
        de: "Steuersatz",
    },
    time: {
        en: "Time",
        de: "Zeitraum",
    },
    timeZone: {
        en: "Time zone",
        de: "Zeitzone",
    },
    transfer: {
        en: "Transfer",
        de: "Übertragen",
    },
    transferOwnership: {
        en: "Transfer Ownership",
        de: "Eigentümerschaft übertragen",
    },
    transferOwnershipDesc: {
        en: "After transferring the ownership, you will remain admin of this location.",
        de: "Nach Übertragen der Eigentümerschaft bleibst du Admin der Sportstätte.",
    },
    transferredOwnershipSuccessfully: {
        en: "Ownership transferred succesfully",
        de: "Eigentümerschaft erfolgreich übertragen",
    },
    visibilityChangedSuccessfully: {
        en: "Visibility changed successfully",
        de: "Sichtbarkeit erfolgreich geändert",
    },
    yes: {
        en: "Yes",
        de: "Ja",
    },
    change: {
        en: "Change",
        de: "Ändern",
    },
    remove: {
        en: "Remove",
        de: "Entfernen",
    },
    fileTooLarge: {
        en: "The file size may not exceed 3 MB",
        de: "Die Datei darf nicht größer als 3 MB sein",
    },
    invalidImageFile: {
        en: "Invalid image file, allowed types are image/png, image/jpg, image/jpeg, image/gif",
        de: "Ungültige Bilddatei, zulässige Typen sind image/png, image/jpg, image/jpeg, image/gif",
    },
    subscription: {
        en: "Subscription",
        de: "Abonnement",
    },
    subscriptionDisabled: {
        en: "This section will be available after demo",
        de: "Dieser Abschnitt wird nach der Demo verfügbar sein",
    },
    subscribe: {
        en: "Subscribe",
        de: "Abonnieren",
    },
    noOfseat: {
        en: "Number of seat",
        de: "Anzahl der Sitzplätze",
    },
    monthlyTotalAmount: {
        en: "Monthly total amount",
        de: "Monatlicher Gesamtbetrag",
    },
    subscriptionSuccess: {
        en: "Subscription success",
        de: "Abonnement erfolgreich",
    },
    subscriptionSuccessMsg: {
        en: "Thank you for your subscription.",
        de: "Vielen Dank für ihr Abonnement.",
    },
    subscriptionSuccessDetailMsg: {
        en: (noOfSeat: number, plan: any) => `You have subscribed ${noOfSeat} seats on ${plan.title}`,
        de: (noOfSeat: number, plan: any) => `Sie haben ${noOfSeat} Sitze bei ${plan.title} abonniert`,
    },
    subscriptionType: {
        en: "Subscription type",
        de: "Abonnementtyp",
    },
    subscriptionTypes: {
        en: {
            standard: "standard",
            advanced: "advanced",
            advanced_plus: "advanced plus",
        },
        de: {
            standard: "standard",
            advanced: "advanced",
            advanced_plus: "advanced plus",
        },
    },
    subscriptionStatus: {
        en: "Status",
        de: "Status",
    },
    subscriptionStatuses: {
        en: {
            active: "active",
            inactive: "inactive",
        },
        de: {
            active: "aktiv",
            inactive: "inaktiv",
        },
    },
    cancelled: {
        en: "cancelled",
        de: "gekündigt",
    },
    pricePerSeat: {
        en: "Price per seat",
        de: "Preis pro Sitzplatz",
    },
    totalPrice: {
        en: "Total amount",
        de: "Gesamtsumme",
    },
    renewalDate: {
        en: "Renewal date",
        de: "Verlängerungsdatum",
    },
    actions: {
        en: "Actions",
        de: "Aktionen",
    },
    subscriptionDetails: {
        en: "Subscription Details",
        de: "Abonnementdetails",
    },
    currentPeriodStart: {
        en: "Current period start",
        de: "Start der aktuellen Periode",
    },
    currentPeriodEnd: {
        en: "Current period end",
        de: "Ende der aktuellen Periode",
    },
    subscriptionInvoice: {
        en: "Invoice Information",
        de: "Rechnungsinformationen",
    },
    subscriptionInvoiceDescription: {
        en: "Description",
        de: "Beschreibung",
    },
    subscriptionCanceledAt: {
        en: "Subscription canceled at",
        de: "Abo gekündigt zum",
    },
    subscriptionInvoiceUrl: {
        en: "Invoice PDF",
        de: "Rechnungs-PDF",
    },
    subscriptionInvoiceDownload: {
        en: "Download",
        de: "Herunterladen",
    },
    subscriptionCardInfo: {
        en: "Card Information",
        de: "Karteninformationen",
    },
    subscriptionCardBrand: {
        en: "Brand",
        de: "Marke",
    },
    subscriptionCard4: {
        en: "Last 4",
        de: "Letzten 4 Ziffern",
    },
    subscriptionCardFunding: {
        en: "Funding",
        de: "Finanzierung",
    },
    subscriptionUpInvoice: {
        en: "Upcoming Invoice",
        de: "Anstehende Rechnung",
    },
    subscriptionUpInvoiceDueDate: {
        en: "Due on",
        de: "Fällig am",
    },
    cancelSubsccriptionMsg: {
        en: "By clicking \"Cancel subscription\", It will cancel the current subscription for the all seats",
        de: "Wenn Sie auf \"Abonnement kündigen\" klicken, wird das aktuelle Abonnement für alle Plätze gekündigt",
    },
    cancelSubscriptionBtn: {
        en: "Cancel subscription",
        de: "Abonnement kündigen",
    },
    cancelSubscriptionSuccessMsg: {
        en: "Your subscription has been canceled",
        de: "Dein Abo wurde gekündigt",
    },
    extendSubscriptionMsg: {
        en: "Extend your subscriptions",
        de: "Extend your subscriptions",
    },
    extendSubscriptionBtn: {
        en: "Proceed",
        de: "WEITER",
    },
    extendSubscriptionSuccessMsg: {
        en: "Your subscription has been succesfully updated",
        de: "Ihr Abonnement wurde erfolgreich aktualisiert",
    },
    insufficientNumberOfPurchasedSeatsMsg: {
        en: (associated: any) => `Your company has more members than you are trying to pay for. Either increase the number of purchased seats to ${associated.currentNumMembers} or remove ${associated.numMembersDifference} member(s) to perform this action.`,
        de: (associated: any) => `Ihr Unternehmen hat mehr Mitglieder, als Sie zu erwerben versuchen. Erhöhen Sie entweder die Anzahl der gekauften Plätze auf ${associated.currentNumMembers} oder entfernen Sie ${associated.numMembersDifference} Mitglied(er), um diese Aktion durchzuführen.`,
    },
    confirmPreviewMsg: {
        en: "The effect of this change that will take place immediately!",
        de: "Wenn Sie auf \"Abonnement kündigen\" klicken, wird das aktuelle Abonnement für alle Plätze gekündigt",
    },
    updateSubscriptionConfirm: {
        en: "Confirm",
        de: "Bestätigen",
    },
    updateSubscriptionSuccessMsg: {
        en: "Thank you for your subscription.",
        de: "Vielen Dank für ihr Abonnement.",
    },
    updateSubscriptionConfirmMsg: {
        en: "Please Confirm.",
        de: "Bitte bestätigen",
    },
    updateSubscription: {
        en: "Update Subscription",
        de: "Abonnement aktualisieren",
    },
    selectPlan: {
        en: "Select Plan",
        de: "Plan auswählen",
    },
    monthlySubscription: {
        en: "Monthly subscription",
        de: "Monatliches Abo",
    },
    currentPlan: {
        en: "Current Plan",
        de: "Derzeitiger Plan",
    },
    changePlan: {
        en: "Change Plan",
        de: "Plan ändern",
    },
    managePlan: {
        en: "Manage Plan",
        de: "PLAN ÄNDERN",
    },
    planDetails: {
        en: "Plan Details",
        de: "Plan Details",
    },
    reActivateSubscription: {
        en: "Re activate subscription",
        de: "Abonnement erneut aktivieren",
    },
    updatedSeatError: {
        en: "You must supply an updated number of seats.",
        de: "You must supply an updated number of seats.",
    },
    confirmDescriptionForSeatAdd: {
        en: (params: any) => `You added ${params.newSeat} additional seat(s), bringing you to a total of ${params.totalSeat} seat(s) on the ${params.plan}.`,
        de: (params: any) => `Sie haben ${params.newSeat} zusätzliche(n) Sitz(e) hinzugefügt, so dass Sie nun insgesamt ${params.totalSeat} Sitz(e) im ${params.plan} haben.`,
    },
    confirmDescriptionForSeatRemove: {
        en: (params: any) => `You removed ${params.newSeat} seat(s), bringing you to a total of ${params.totalSeat} seat(s) on the ${params.plan}.`,
        de: (params: any) => `Sie haben ${params.newSeat} Sitz(e) entfernt, so dass Sie nun insgesamt ${params.totalSeat} Sitz(e) im ${params.plan} haben.`,
    },
    confirmImmediateTotalTextGreaterThanZero: {
        en: (params: any) => `You will be charged  ${params.immediateTotal} today.`,
        de: (params: any) => `Sie werden heute mit ${params.immediateTotal} belastet.`,
    },
    confirmnextPaymentTextGreaterThanZero: {
        en: (params: any) => `Your next payment of ${params.nextInvoiceTotal} will be due ${params.upcomingInvoice}`,
        de: (params: any) => `Ihre nächste Zahlung von ${params.nextInvoiceTotal} wird am ${params.upcomingInvoice} fällig.`,
    },
    confirmImmediateTotalTextLessThanZero: {
        en: (params: any) => `There's nothing due today. You have a credit of ${params.immediateTotal} that will be applied to your next invoice of ${params.nextInvoiceTotal} , due on ${params.upcomingInvoice} .`,
        de: (params: any) => `Heute wird keine Zahlung fällig. Sie haben ein Guthaben von ${params.immediateTotal}, das auf Ihre nächste Rechnung von ${params.immediateTotal}, fällig am ${params.upcomingInvoice}, angerechnet wird.`,
    },
    add: {
        en: "Add",
        de: "Hinzufügen",
    },
    addMore: {
        en: "Add More",
        de: "Mehr hinzufügen",
    },
    close: {
        en: "Close",
        de: "SCHLIESSEN",
    },
    notice: {
        en: "Notice",
        de: "Hinweis",
    },
    demoModeMsg: {
        en: "To select a subscription you have to go live and end the demo phase.",
        de: "Um ein Abonnement auszuwählen, musst du die Demo-Phase beenden und live gehen.",
    },
    selectDefaultPaymentMethod: {
        en: "Select default payment method",
        de: "Wählen Sie die Standardzahlungsmethode",
    },
    cardNumber: {
        en: "Card number:",
        de: "Kartennummer:",
    },
    paymentType: {
        en: "Payment Type",
        de: "Zahlungsart",
    },
};

export default localize(i18n);
